// extracted by mini-css-extract-plugin
export default {"Company":"company_Company__4Q3QT","selectCompany":"company_selectCompany__bR9zu","Appheader":"company_Appheader__RYHcp","divStyle":"company_divStyle__2iojk"};